import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolToYesNo'
})
export class BoolToYesNoPipe implements PipeTransform {

  transform(value: boolean | number): string {
    if (value) {
      return 'Yes';
    }

    return 'No';
  }

}
